import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/imgs/Sidebar/openbook.png'
import _imports_1 from '@/assets/imgs/Sidebar/openapply.png'
import _imports_2 from '@/assets/imgs/Sidebar/process.png'
import _imports_3 from '@/assets/imgs/Sidebar/approval.png'
import _imports_4 from '@/assets/imgs/Sidebar/changelist.png'


const _withScopeId = n => (_pushScopeId("data-v-93a468c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "side-container"
}
const _hoisted_2 = {
  class: "side-box",
  ref: "sideBox"
}
const _hoisted_3 = {
  key: 0,
  alt: "",
  src: _imports_0,
  width: "16px"
}
const _hoisted_4 = {
  key: 1,
  src: _imports_1,
  width: "16px"
}
const _hoisted_5 = {
  key: 2,
  src: _imports_2,
  width: "16px"
}
const _hoisted_6 = {
  key: 3,
  src: _imports_3,
  width: "16px"
}
const _hoisted_7 = {
  key: 0,
  class: "circle"
}
const _hoisted_8 = {
  key: 1,
  class: "circle"
}
const _hoisted_9 = {
  key: 0,
  alt: "",
  src: _imports_0,
  width: "16px"
}
const _hoisted_10 = {
  key: 1,
  src: _imports_4,
  width: "16px"
}
const _hoisted_11 = { class: "ant-menu-title-content-block" }
const _hoisted_12 = {
  key: 1,
  class: "side-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_sub_menu = _resolveComponent("a-sub-menu")!
  const _component_a_menu = _resolveComponent("a-menu")!

  return (_ctx.menuList.length != 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_a_menu, {
            openKeys: _ctx.openKeys,
            "onUpdate:openKeys": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.openKeys) = $event)),
            "selected-keys": _ctx.selectedKeys,
            "onUpdate:selected-keys": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedKeys) = $event)),
            style: {"width":"160px"},
            mode: "inline",
            onClick: _ctx.handleClick,
            "inline-collapsed": false
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuList, (_item, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                  (_item.Child)
                    ? (_openBlock(), _createBlock(_component_a_sub_menu, {
                        key: _item.Index
                      }, {
                        icon: _withCtx(() => [
                          (_item.Icon === 'openbook')
                            ? (_openBlock(), _createElementBlock("img", _hoisted_3))
                            : _createCommentVNode("", true),
                          (_item.Icon === 'openapply')
                            ? (_openBlock(), _createElementBlock("img", _hoisted_4))
                            : (_item.Icon === 'openprocess')
                              ? (_openBlock(), _createElementBlock("img", _hoisted_5))
                              : (_item.Icon === 'approval')
                                ? (_openBlock(), _createElementBlock("img", _hoisted_6))
                                : _createCommentVNode("", true)
                        ]),
                        title: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_item.Name), 1)
                        ]),
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_item.Child, (menuitem) => {
                            return (_openBlock(), _createBlock(_component_a_menu_item, {
                              key: menuitem.Index,
                              class: "menu-circle"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(menuitem.Name) + " ", 1),
                                (menuitem.Index === 'signsure' && _ctx.num != 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.num), 1))
                                  : _createCommentVNode("", true),
                                (menuitem.Index === 'signcopy' && _ctx.to_num != 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.to_num), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 2
                      }, 1024))
                    : (_openBlock(), _createBlock(_component_a_menu_item, {
                        key: _item.Index,
                        class: "menu-open"
                      }, {
                        icon: _withCtx(() => [
                          (_item.Icon === 'openbook')
                            ? (_openBlock(), _createElementBlock("img", _hoisted_9))
                            : (_item.Icon === 'changelist')
                              ? (_openBlock(), _createElementBlock("img", _hoisted_10))
                              : _createCommentVNode("", true)
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_11, _toDisplayString(_item.Name), 1)
                        ]),
                        _: 2
                      }, 1024))
                ], 64))
              }), 128))
            ]),
            _: 1
          }, 8, ["openKeys", "selected-keys", "onClick"])
        ], 512)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_12))
}